import axios from "axios";
import config from "@/config";

export default {
  getHolidayPlanList(page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/holiday-year`, {
      params: {
        page: page,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateHolidayPlan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/holiday-year/update`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createHolidayPlan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/holiday-year`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteHolidayPlan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/holiday-year/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getProfileBranchList(page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/profile-branch`, {
      params: {
        page: page,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getBranchByCode(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/profile-branch/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  saveBranch(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/profile-branch`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateBranch(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/profile-branch/update`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteProfileBranch(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/profile-branch/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getProfileDepartmentList(page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/profile-department/`, {
      params: {
        page: page,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getDepartmentByCode(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/profile-department/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getDepartmentByBranch(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/profile-department/branch/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteProfileDepartment(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/profile-department/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createDepartment(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/profile-department`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateDepartment(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/profile-department/update`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getWorkPlanList() {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/profile-shift/`, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getCompanyAddress() {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/address-setting`, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  saveCompanyAddress(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/address-setting`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateCompanyAddress(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/address-setting/update`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getGeneralSetting() {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/general-setting`, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  saveGeneralSetting(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/general-setting`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateGeneralSetting(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/general-setting/update`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getTaxSetting() {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/tax-setting`, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  // saveTax(data) {
  //     const _token = localStorage._token;
  //     const _company_guid = localStorage._company_guid;
  //     const http = axios.create({
  //         baseURL: config.API_URL
  //     });
  //     return http.post(`/tax-setting`, data, {
  //         headers: {
  //             'Content-Type': 'application/json',
  //             'Authorization': 'Bearer ' + _token,
  //             'X-TenantID': _company_guid
  //         }
  //     });
  // },
  createTaxdetail(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/tax-detail`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateTaxdetail(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.put(`/tax-detail`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  editTaxdetail(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.put(`/tax-detail`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getTaxdetail(year) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/tax-detail`, {
      params: {
        year: year,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getDecimalSetting() {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/decimal-setting`, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  saveDecimal(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/decimal-setting`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getDeviceList(page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/device-setting`, {
      params: {
        page: page,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getDeviceByCode(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/device-setting/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateDevice(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.put(`/device-setting/`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createNewDevice(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/device-setting`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteDevice(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/device-setting/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getMapEmpScanerList(page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/map-emp-scaner`, {
      params: {
        page: page,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getMapEmpScanerByCode(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/map-emp-scaner/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createMapEmpScaner(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/map-emp-scaner`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateMapEmpScaner(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.put(`/map-emp-scaner`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteMapEmpScaner(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/map-emp-scaner/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getProfilePlan() {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/profile-shift/time`, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getProfileAllPlan(page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/profile-shift`, {
      params: {
        page: page,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateProfilePlan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/profile-shift/update`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createProfilePlan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/profile-shift`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteProfilePlan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/profile-shift/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getProfileConditions(page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/deduction-conditions`, {
      params: {
        page: page,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteProfileConditions(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/deduction-conditions/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createProfileConditions(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/deduction-conditions`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateProfileConditions(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/deduction-conditions/update`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getDataCompany() {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get("/address-setting", {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  setShop() {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get("/company/setshop/" + _company_guid, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },

  getHolidayList(page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/year-holiday`, {
      params: {
        page: page,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateHolidayList(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.put(`/year-holiday`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createHolidayList(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/year-holiday`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteHolidayList(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/year-holiday/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  saveBranchList(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/profile-branch/import`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createDepartmentList(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/profile-department/import`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  gettaxList(page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/tax-detail/filter`, {
      params: {
        page: page,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateShopName(guid, shopname, is_timeattendance) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/company/updateshop`, {
      params: {
        guid: guid,
        shopname: shopname,
        is_timeattendance: is_timeattendance,
        companyid: _company_guid,
      },

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
};
